export default __webpack_public_path__ + "static/media/RollingDices.4ea49309.mp3";